// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3dd8951a","453":"c108aea8","455":"026b5cf6"}[chunkId] + ".chunk.js";
};